<template>
    <div class="dropdown">
        <button
            id="dropdownMenuButton"
            class="btn btn-sm p-0 dropdown-toggle"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <i class="far fa-bars"></i>
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <b-link v-if="item.done" class="dropdown-item" @click="readTask">
                <i class="far fa-check fa-fw"></i> Vu
            </b-link>
            <b-link class="dropdown-item" @click="editTask">
                <i class="far fa-pencil fa-fw"></i> Modifier
            </b-link>
            <b-link
                v-if="item.can_edit"
                class="dropdown-item"
                @click="confirmDelete"
            >
                <i class="far fa-trash-alt fa-fw"></i> Supprimer
            </b-link>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../dashboard/mixins/DataUpdater.vue'

export default {
    name: 'TaskMenu',

    mixins: [DataUpdater],

    props: {
        item: {
            type: Object,
            required: true,
        },
    },

    computed: {
        ...mapState({
            deadlineFilter: (state) => state.browsing.deadlineFilter,
        }),

        isTask() {
            return this.item.assigned_to !== null
        },

        modalTitle() {
            return this.isTask
                ? "Suppression d'une tâche"
                : "Suppression d'un évènement"
        },

        modalMessage() {
            return this.isTask
                ? 'Etes-vous sûr·e de vouloir supprimer cette tâche ?'
                : 'Etes-vous sûr·e de vouloir supprimer cet évènement ?'
        },
    },

    methods: {
        async readTask() {
            try {
                await this.$axios.put(`/clientEvents/${this.item.id}/read`)
                this.updateData()
            } catch (error) {
                error.log(error)
            }
        },

        editTask() {
            this.$store.commit('data/SET_EDITED_TASK', this.item)
            this.$store.commit('browsing/SET_EDITING')
            this.$store.commit('browsing/SET_PAGE_NAME', 'tasks.edit')
        },

        confirmDelete() {
            this.$bvModal
                .msgBoxConfirm(this.modalMessage, {
                    title: this.modalTitle,
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'OUI',
                    cancelTitle: 'NON',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        this.deleteEvent()
                    }
                })
                .catch(() => {
                    // An error occurred
                })
        },

        async deleteEvent() {
            try {
                await this.$axios.delete(`/clientEvents/${this.item.id}`)
                document.location.reload()
            } catch (error) {
                error.log(error)
            }
        },
    },
}
</script>

<style scoped></style>
